import React, { useState, useEffect } from 'react'
import { GetEmployeeBalanceCount, GetEmployeeHistoryCount, UpdateEmployeeHistoryCount, UpdateEmployeeBalanceCount } from '../../Repository/Api'
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Restrict } from './FinancialYear';
import { successMsg } from '../Toastify';
import CustomModal from '../CustomModal';

const LeaveHistory = () => {
    const { access_token } = useSelector((state) => state?.auth?.auth);
    const token = access_token
    const { id } = useParams();
    const tabs = ["History Count", "Balance Count   "]
    const [active, setActive] = useState(0)
    const [historyCount, setHistoryCount] = useState()
    const [balanceCount, setBalanceCount] = useState()
    const [openModal, setOpenModal] = useState(false)
    // console.log(historyCount)
    const getHistoryCount = async () => {
        const response = await GetEmployeeHistoryCount(token, id)
        if (response && response.statusCode === 200) {
            setHistoryCount(response.data)
        }
    }
    const getBalanceCount = async () => {
        const response = await GetEmployeeBalanceCount(token, id)
        if (response && response.statusCode === 200) {
            setBalanceCount(response.data)
        }
    }

    const setData = (key, value) => {
        setHistoryCount({
            ...historyCount,
            [key]: Number(value)
        })
    }

    const setBalance = (key, value) => {
        setBalanceCount({
            ...balanceCount,
            [key]: Number(value)
        })
    }
    const handleHistoryCountSubmit = async (e) => {
        e.preventDefault()
        const payload = {
            employee_id: id,
            casual_leave: historyCount.casual_leave,
            earned_leave: historyCount.earned_leave,
            child_care_leave: historyCount.child_care_leave,
            comp_off: historyCount.comp_off,
            extra_ordinary_leave: historyCount.extra_ordinary_leave,
            maternity_leave: historyCount.maternity_leave,
            medical_leave: historyCount.medical_leave,
            on_duty: historyCount.on_duty,
            out_of_station: historyCount.out_of_station,
            paternity_leave: historyCount.paternity_leave,
            permissions: historyCount.permissions,
            restricted_holiday: historyCount.restricted_holiday,
            special_casual_leave: historyCount.special_casual_leave,
        }
        // console.log(payload)
        const response = await UpdateEmployeeHistoryCount(token, payload)
        if (response && response.statusCode === 200) {
            setOpenModal(false)
            successMsg(response.message)
            getHistoryCount()
        }
        // console.log(response)
    }
    const handleBalanceCountSubmit = async (e) => {
        e.preventDefault()
        const payload = {
            employee_id: id,
            earned_leave: balanceCount.earned_leave,
            child_care_leave: balanceCount.child_care_leave,
            maternity_leave: balanceCount.maternity_leave,
            medical_leave: balanceCount.medical_leave,
            paternity_leave: balanceCount.paternity_leave,
        }
        // console.log(payload)
        const response = await UpdateEmployeeBalanceCount(token, payload)
        if (response && response.statusCode === 200) {
            setOpenModal(false)
            successMsg(response.message)
            getBalanceCount()
        }
        // console.log(response)
    }

    useEffect(() => {
        getHistoryCount()
        getBalanceCount()
    }, [])
    return (
        <div>
            <div className="row my-4">
                <div className="col-lg-4 mx-auto ms-auto">
                    <ul className="searchtopflex">
                        {tabs.map((link, index) => {
                            return (
                                <li
                                    onClick={() => setActive(index)}
                                    key={link}
                                    className={
                                        active === index
                                            ? "agenttextactive"
                                            : "agenttextinactive"
                                    }
                                >
                                    {link}
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
            {active === 0 &&
                <div>
                    <div className='row'>
                        <div className='col-lg-3'>
                            <label className="labeltext">Earned Leave</label>
                            <input
                                type="number"
                                min={0}
                                max={999}
                                onWheelCapture={e => { e.target.blur() }}
                                onKeyDown={(e) => Restrict(e)}
                                onInput={(e) => e.target.value = e.target.value.slice(0, 3)}
                                className="fieldinput"
                                defaultValue={historyCount?.earned_leave}
                                onChange={(e) => setData('earned_leave', e.target.value)}
                            />
                        </div>
                        <div className='col-lg-3'>
                            <label className="labeltext">Medical Leave</label>
                            <input
                                type="number"
                                min={0}
                                max={999}
                                onWheelCapture={e => { e.target.blur() }}
                                onKeyDown={(e) => Restrict(e)}
                                onInput={(e) => e.target.value = e.target.value.slice(0, 3)}
                                className="fieldinput"
                                defaultValue={historyCount?.medical_leave}
                                onChange={(e) => setData('medical_leave', e.target.value)}

                            />
                        </div>
                        <div className='col-lg-3'>
                            <label className="labeltext">Casual Leave</label>
                            <input
                                type="number"
                                min={0}
                                max={999}
                                onWheelCapture={e => { e.target.blur() }}
                                onKeyDown={(e) => Restrict(e)}
                                // onInput={(e) => e.target.value = e.target.value.slice(0, 3)}
                                className="fieldinput"
                                defaultValue={historyCount?.casual_leave}
                                onChange={(e) => setData('casual_leave', e.target.value)}
                                step={0.5}
                            />
                        </div>
                        <div className='col-lg-3'>
                            <label className="labeltext">Extra Ordinary Leave</label>
                            <input
                                type="number"
                                min={0}
                                max={999}
                                onWheelCapture={e => { e.target.blur() }}
                                onKeyDown={(e) => Restrict(e)}
                                onInput={(e) => e.target.value = e.target.value.slice(0, 3)}
                                className="fieldinput"
                                defaultValue={historyCount?.extra_ordinary_leave}
                                onChange={(e) => setData('extra_ordinary_leave', e.target.value)}

                            />
                        </div>
                        <div className='col-lg-3'>
                            <label className="labeltext">Restricted Holiday</label>
                            <input
                                type="number"
                                min={0}
                                max={999}
                                onWheelCapture={e => { e.target.blur() }}
                                onKeyDown={(e) => Restrict(e)}
                                onInput={(e) => e.target.value = e.target.value.slice(0, 3)}
                                className="fieldinput"
                                defaultValue={historyCount?.restricted_holiday}
                                onChange={(e) => setData('restricted_holiday', e.target.value)}

                            />
                        </div>
                        <div className='col-lg-3'>
                            <label className="labeltext">Maternity Leave</label>
                            <input
                                type="number"
                                min={0}
                                max={999}
                                onWheelCapture={e => { e.target.blur() }}
                                onKeyDown={(e) => Restrict(e)}
                                onInput={(e) => e.target.value = e.target.value.slice(0, 3)}
                                className="fieldinput"
                                defaultValue={historyCount?.maternity_leave}
                                onChange={(e) => setData('maternity_leave', e.target.value)}

                            />
                        </div>
                        <div className='col-lg-3'>
                            <label className="labeltext">Paternity Leave</label>
                            <input
                                type="number"
                                min={0}
                                max={999}
                                onWheelCapture={e => { e.target.blur() }}
                                onKeyDown={(e) => Restrict(e)}
                                onInput={(e) => e.target.value = e.target.value.slice(0, 3)}
                                className="fieldinput"
                                defaultValue={historyCount?.paternity_leave}
                                onChange={(e) => setData('paternity_leave', e.target.value)}

                            />
                        </div>
                        <div className='col-lg-3'>
                            <label className="labeltext">Child Care Leave</label>
                            <input
                                type="number"
                                min={0}
                                max={999}
                                onWheelCapture={e => { e.target.blur() }}
                                onKeyDown={(e) => Restrict(e)}
                                onInput={(e) => e.target.value = e.target.value.slice(0, 3)}
                                className="fieldinput"
                                defaultValue={historyCount?.child_care_leave}
                                onChange={(e) => setData('child_care_leave', e.target.value)}

                            />
                        </div>
                        <div className='col-lg-3'>
                            <label className="labeltext">Special Casual Leave</label>
                            <input
                                type="number"
                                min={0}
                                max={999}
                                onWheelCapture={e => { e.target.blur() }}
                                onKeyDown={(e) => Restrict(e)}
                                onInput={(e) => e.target.value = e.target.value.slice(0, 3)}
                                className="fieldinput"
                                defaultValue={historyCount?.special_casual_leave}
                                onChange={(e) => setData('special_casual_leave', e.target.value)}

                            />
                        </div>
                        <div className='col-lg-3'>
                            <label className="labeltext">Comp Off</label>
                            <input
                                type="number"
                                min={0}
                                max={999}
                                onWheelCapture={e => { e.target.blur() }}
                                onKeyDown={(e) => Restrict(e)}
                                onInput={(e) => e.target.value = e.target.value.slice(0, 3)}
                                className="fieldinput"
                                defaultValue={historyCount?.comp_off}
                                onChange={(e) => setData('comp_off', e.target.value)}

                            />
                        </div>
                        <div className='col-lg-3'>
                            <label className="labeltext">On Duty</label>
                            <input
                                type="number"
                                min={0}
                                max={999}
                                onWheelCapture={e => { e.target.blur() }}
                                onKeyDown={(e) => Restrict(e)}
                                onInput={(e) => e.target.value = e.target.value.slice(0, 3)}
                                className="fieldinput"
                                defaultValue={historyCount?.on_duty}
                                onChange={(e) => setData('on_duty', e.target.value)}

                            />
                        </div>
                        <div className='col-lg-3'>
                            <label className="labeltext">Out Of Station</label>
                            <input
                                type="number"
                                min={0}
                                max={999}
                                onWheelCapture={e => { e.target.blur() }}
                                onKeyDown={(e) => Restrict(e)}
                                onInput={(e) => e.target.value = e.target.value.slice(0, 3)}
                                className="fieldinput"
                                defaultValue={historyCount?.out_of_station}
                                onChange={(e) => setData('out_of_station', e.target.value)}

                            />
                        </div>
                        <div className='col-lg-3'>
                            <label className="labeltext">Permissions</label>
                            <input
                                type="number"
                                min={0}
                                max={999}
                                onWheelCapture={e => { e.target.blur() }}
                                onKeyDown={(e) => Restrict(e)}
                                onInput={(e) => e.target.value = e.target.value.slice(0, 3)}
                                className="fieldinput"
                                defaultValue={historyCount?.permissions}
                                onChange={(e) => setData('permissions', e.target.value)}

                            />
                        </div>
                    </div>
                    <div className="mt-5 text-center">
                        <button
                            className="requestbtn"
                            // onClick={handleHistoryCountSubmit}
                            onClick={() => setOpenModal(true)}
                        >Update</button>
                    </div>
                </div>
            }
            {active === 1 &&
                <div>
                    <div className='row'>
                        <div className='col-lg-3'>
                            <label className="labeltext">Child Care Leave</label>
                            <input
                                type="number"
                                min={0}
                                max={999}
                                onWheelCapture={e => { e.target.blur() }}
                                onKeyDown={(e) => Restrict(e)}
                                onInput={(e) => e.target.value = e.target.value.slice(0, 3)}
                                className="fieldinput"
                                defaultValue={balanceCount?.child_care_leave}
                                onChange={(e) => setBalance('child_care_leave', e.target.value)}

                            />
                        </div>
                        <div className='col-lg-3'>
                            <label className="labeltext">Earned Leave</label>
                            <input
                                type="number"
                                min={0}
                                max={999}
                                onWheelCapture={e => { e.target.blur() }}
                                onKeyDown={(e) => Restrict(e)}
                                onInput={(e) => e.target.value = e.target.value.slice(0, 3)}
                                className="fieldinput"
                                defaultValue={balanceCount?.earned_leave}
                                onChange={(e) => setBalance('earned_leave', e.target.value)}

                            />
                        </div>
                        <div className='col-lg-3'>
                            <label className="labeltext">Maternity Leave</label>
                            <input
                                type="number"
                                min={0}
                                max={999}
                                onWheelCapture={e => { e.target.blur() }}
                                onKeyDown={(e) => Restrict(e)}
                                onInput={(e) => e.target.value = e.target.value.slice(0, 3)}
                                className="fieldinput"
                                defaultValue={balanceCount?.maternity_leave}
                                onChange={(e) => setBalance('maternity_leave', e.target.value)}

                            />
                        </div>
                        <div className='col-lg-3'>
                            <label className="labeltext">Medical Leave</label>
                            <input
                                type="number"
                                min={0}
                                max={999}
                                onWheelCapture={e => { e.target.blur() }}
                                onKeyDown={(e) => Restrict(e)}
                                onInput={(e) => e.target.value = e.target.value.slice(0, 3)}
                                className="fieldinput"
                                defaultValue={balanceCount?.medical_leave}
                                onChange={(e) => setBalance('medical_leave', e.target.value)}

                            />
                        </div>
                        <div className='col-lg-3'>
                            <label className="labeltext">Paternity Leave</label>
                            <input
                                type="number"
                                min={0}
                                max={999}
                                onWheelCapture={e => { e.target.blur() }}
                                onKeyDown={(e) => Restrict(e)}
                                onInput={(e) => e.target.value = e.target.value.slice(0, 3)}
                                className="fieldinput"
                                defaultValue={balanceCount?.paternity_leave}
                                onChange={(e) => setBalance('paternity_leave', e.target.value)}

                            />
                        </div>
                    </div>
                    <div className="mt-5 text-center">
                        <button
                            className="requestbtn"
                            // onClick={handleBalanceCountSubmit}
                            onClick={() => setOpenModal(true)}
                        >Update</button>
                    </div>
                </div>
            }
            <CustomModal
                open={openModal}
                onClickOutside={() => {
                    setOpenModal(false);
                }}
            >
                <div className="modal-content Modal-View m-auto">
                    <div className="modalHeader text-center py-2">
                        <h5 className="font-bold mt-2">Confirmation !</h5>
                    </div>
                    <div className="modal-body p-0">
                        <div className="container">
                            <div></div>
                            <div>
                                <h6 className="confirmmodeltext my-4">
                                    Are You Sure?
                                </h6>
                            </div>
                            <div>
                                <h6 className="confirmmodeltext my-4">
                                    Once Submitted cannot be revote this !
                                </h6>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer border-0">
                        <div className="my-3">
                            <button
                                type="button"
                                className="btn mx-2 modelclosebtn"
                                onClick={() => {
                                    setOpenModal(false);
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                        <div>
                            {active === 0 ?
                                <button
                                    className="btn mx-2 approvebutton"
                                    onClick={handleHistoryCountSubmit}
                                >
                                    yes, Submit
                                </button> : active === 1 ? <button
                                    className="btn mx-2 approvebutton"
                                    onClick={handleBalanceCountSubmit}
                                >
                                    yes, Submit
                                </button> : ''}
                        </div>
                    </div>
                </div>
            </CustomModal>
        </div>
    )
}

export default LeaveHistory